import React, { useState } from 'react';
import './App.css';
import Receiver from './components/Receiver';
import Sender from './components/Sender';

function App() {
  const [view, setView] = useState('chooser'); // 'chooser', 'sender', or 'receiver'

  const renderView = () => {
    switch (view) {
      case 'sender':
        return <Sender goBack={() => setView('chooser')} />;
      case 'receiver':
        return <Receiver goBack={() => setView('chooser')} />;
      default:
        return (
          <div className="chooser-container">
            <button className="chooser-button" onClick={() => setView('sender')}>
              <i className="fas fa-upload"></i>
              <span>Send</span>
            </button>
            <button className="chooser-button" onClick={() => setView('receiver')}>
              <i className="fas fa-download"></i>
              <span>Receive</span>
            </button>
          </div>
        );
    }
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1>Local Transfer</h1>
      </header>
      <main>
        {renderView()}
      </main>
    </div>
  );
}

export default App;
